import styled from 'styled-components';

import mixin from '../../../_foundations/Mixin';

export const JobListItemContainer = styled.div`
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  column-gap: 0.75rem;
  padding: 0.75rem;
  ${mixin.border()}
  border-width: 0 0 1px;
  max-width: 100%;
  cursor: pointer;

  &:hover {
    background: var(--neutral-100);
  }
`;

export const JobTitle = styled.h3`
  ${mixin.text({ size: 200, strong: true })}
  color: var(--neutral-900);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const JobLocation = styled.div``;

export const JobInfo = styled.div`
  ${mixin.text({ size: 100 })}
`;

export const JobIcon = styled.div``;

export const JobLogo = styled.img``;

export const CustomPin = styled.img`
  cursor: pointer;
  zindex: 10;
  user-select: none;
  width: 42px;
  height: 42px;
  object-fit: contain;
`;
